<div class="fat-tab">
  <div class="actions">
    <button class="btn btn-primary btn-with-icon" (click)="askStartFat()"
      [disabled]="isLoading || hasDraftFat() || hasCompletedCompliantLatestFat() || !canStartFat() || !hasValidatedTemplate">
      <mat-icon aria-hidden="true">play_arrow</mat-icon>
      Démarrer une FAT
    </button>
  </div>
  @if (!hasValidatedTemplate) {
  <div class="alert alert-warning">
    Aucun template FAT validé n'existe. Veuillez d'abord valider un template pour pouvoir démarrer une FAT.
  </div>
  }
  @if (hasDraftFat()) {
  <div class="alert alert-warning">
    Une FAT en brouillon (DRAFT) existe déjà sur ce projet. Finalisez-la avant d'en démarrer une nouvelle.
  </div>
  }
  @if (hasCompletedCompliantLatestFat()) {
  <div class="alert alert-warning">
    La dernière FAT du projet est terminée et conforme. Aucune nouvelle FAT ne peut être démarrée.
  </div>
  }

  <div *ngIf="isLoading" class="loading-state">Chargement des FAT...</div>

  <div class="list" *ngIf="!isLoading && fats.length > 0; else emptyState">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>N° FAT</th>
          <th>Statut</th>
          <th>Créée le</th>
          <th>Terminée le</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fat of fats" (click)="selectFat(fat)" class="clickable-row">
          <td>{{ fat.fatNumber || fat.id }}</td>
          <td>
            <span class="status-badge" [attr.data-meta]="fat.statusMeta || null"
              [style.background-color]="fat.statusColor || null">
              {{ fat.status }}
            </span>
          </td>
          <td>{{ fat.createdAt | date:'dd/MM/yyyy à HH:mm' }}</td>
          <td>{{ fat.finishedAt ? (fat.finishedAt | date:'dd/MM/yyyy à HH:mm') : '-' }}</td>
          <td class="table-actions">
            @if (fat.status === 'FAT non conforme' || fat.status === 'FAT terminée' || fat.status === 'FAT conforme' ||
            fat.status === 'FAT validée') {
            <button class="btn btn-icon-only" (click)="exportFat(fat, $event)" title="Imprimer la FAT"
              [disabled]="isLoadingExport">
              <mat-icon>print</mat-icon>
            </button>
            }
            <button class="btn btn-icon-only" (click)="selectFat(fat)" title="Voir/Remplir">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #emptyState>
    <div class="empty-state" *ngIf="!isLoading">
      <mat-icon aria-hidden="true">assignment</mat-icon>
      <p>Aucune FAT pour ce projet.</p>
    </div>
  </ng-template>


  @if (showErrorDialog) {
  <app-confirm-dialog [title]="errorDialogTitle" [message]="errorDialogMessage" (confirmed)="closeErrorDialog()"
    (cancelled)="closeErrorDialog()">
  </app-confirm-dialog>
  }
</div>
